/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ObjectResult } from '../../models/object-result';
import { UpdatePlayerOptionsCommand } from '../../models/update-player-options-command';

export interface ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params {
      body?: UpdatePlayerOptionsCommand
}

export function apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse(http: HttpClient, rootUrl: string, params?: ApiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json;odata.metadata=none;odata.streaming=true');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=full;odata.streaming=false', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ObjectResult>;
    })
  );
}

apiPlayerOptionsPost$JsonOdataMetadataNoneOdataStreamingTrue$JsonOdataMetadataFullOdataStreamingFalse.PATH = '/api/player/options';
